import React from 'react';

const Overlay = ({ children }) => (
	<div class="overlay">{children}</div>
);

export default Overlay;
